module.exports = __webpack_public_path__ + "img/load-3-2.d3cafaa1.png";